import { InputLabel, InputLabelProps, styled } from "@mui/material";
import React from "react";

export interface MxLabelProps extends InputLabelProps {
  children: string | React.ReactNode;
  name?: string;
}
const MxInputLabel = (props: MxLabelProps) => {
  return <CInputLabel {...props} htmlFor={props.htmlFor ?? `${props.name}-input`} />;
};
export default MxInputLabel;

const CInputLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.primary.main
}));
